import { defineMessages } from 'react-intl';

export default defineMessages({
  shippingLabelMissing: {
    id: 'view.myccount.shippingLabelMissing',
    defaultMessage: 'No shipping label found',
  },
  ShippingLabel: {
    id: 'view.myccount.shippingLabel',
    defaultMessage: 'Shipping label',
  },
  downloadDocument: {
    id: 'view.myccount.fileDocmuent.downloadDocument',
    defaultMessage: 'Download',
  },
});
